import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';

// Components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import newlogo from '../../assets/img/new-logo.png';

class SignUpPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contactForm: {
                company: '',
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                comment: '',
                note: 'Sign Up Contact',
                accept: false,
            },
        };
    }

    handleFormChange = (name, value) => {
        const contactForm = Object.assign({}, this.state.contactForm);
        contactForm[name] = value;
        this.setState({ contactForm });
    };

    contactSubmit = (e) => {
        e.preventDefault();
        this.props.commonStore.sendContact(this.state.contactForm).then(() => {
            this.props.commonStore.addNotification(
                this.props.t('Your message has been sent, thank you.'),
                null,
                'success'
            );
            this.setState({
                contactForm: {
                    company: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    comment: '',
                    note: 'Sign Up Contact',
                    accept: false,
                },
            });
        });
    };

    render() {
        const { t } = this.props;
        const { contactForm } = this.state;

        return (
            <div>
                <div className="auth-page-wrapper">
                    <ToastContainer />
                    <div className="auth-page-card" style={{ maxWidth: 620 }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h2 className="fs22 loginTitle">{t('Sign Up').toUpperCase()}</h2>
                            <img src={newlogo} alt="Logo" style={{ height: 42, cursor: 'pointer' }} onClick={() => this.props.router.navigate('/')} />
                        </div>
                        <form className="login-container" onSubmit={this.contactSubmit}>
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                    <div className="form-group business-name">
                                        <label htmlFor="businessName" className="fw-bold">
                                            {t('Business Name')}
                                        </label>
                                        <label className="red-star">*</label>
                                        <input
                                            id="businessName"
                                            type="text"
                                            value={contactForm.company}
                                            onChange={(e) => this.handleFormChange('company', e.target.value)}
                                            className="form-control login-input mb_25 mt-1"
                                            placeholder={t('Business Name')}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row g-3">
                                <div className="col-md-6 col-sm-12 col-xs-12">
                                    <div className="form-group business-name">
                                        <label htmlFor="firstName" className="fw-bold">
                                            {t('First Name')}
                                        </label>
                                        <label className="red-star">*</label>
                                        <input
                                            id="firstName"
                                            type="text"
                                            value={contactForm.firstName}
                                            onChange={(e) => this.handleFormChange('firstName', e.target.value)}
                                            className="form-control login-input mt-1 mb_25"
                                            placeholder={t('First Name')}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12 col-xs-12">
                                    <div className="form-group business-name">
                                        <label htmlFor="lastName" className="fw-bold">
                                            {t('Last Name')}
                                        </label>
                                        <label className="red-star">*</label>
                                        <input
                                            id="lastName"
                                            type="text"
                                            value={contactForm.lastName}
                                            onChange={(e) => this.handleFormChange('lastName', e.target.value)}
                                            className="form-control login-input mt-1 mb_25"
                                            placeholder={t('Last Name')}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row g-3">
                                <div className="col-md-6 col-sm-12 col-xs-12">
                                    <div className="form-group business-name">
                                        <label htmlFor="signupEmail" className="fw-bold">
                                            {t('Email')}
                                        </label>
                                        <label className="red-star">*</label>
                                        <input
                                            id="signupEmail"
                                            type="email"
                                            value={contactForm.email}
                                            onChange={(e) => this.handleFormChange('email', e.target.value)}
                                            className="form-control login-input mb_25 mt-1"
                                            placeholder={t('Email address')}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12 col-xs-12">
                                    <div className="form-group business-name">
                                        <label htmlFor="mobileNumber" className="fw-bold">
                                            {t('Mobile Number')}
                                        </label>
                                        <label className="red-star">*</label>
                                        <input
                                            id="mobileNumber"
                                            type="text"
                                            value={contactForm.phone}
                                            onChange={(e) => this.handleFormChange('phone', e.target.value)}
                                            className="form-control login-input mb_25 mt-1"
                                            placeholder={t('Mobile Number')}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                    <div className="form-group business-name">
                                        <label htmlFor="comment" className="fw-bold">
                                            {t('Comment')}
                                        </label>
                                        <label className="red-star">*</label>
                                        <textarea
                                            id="comment"
                                            className="form-control text_area mt-1"
                                            required
                                            value={contactForm.comment}
                                            placeholder={t('Comments')}
                                            onChange={(e) => this.handleFormChange('comment', e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-check mb-3">
                                <input
                                    type="checkbox"
                                    checked={contactForm.accept}
                                    onChange={(e) => this.handleFormChange('accept', e.target.checked)}
                                    className="form-check-input"
                                    id="acceptTerms"
                                />
                                <label className="form-check-label2 signupTandC" htmlFor="acceptTerms">
                                    &nbsp; {t('I accept the')} &nbsp;
                                    <a>{t('Terms & Conditions')}</a>
                                </label>
                            </div>
                            <button className="btn btn-block fwBold fs18 loginbutton" type="submit">
                                {t('Sign Up').toUpperCase()}
                            </button>
                        </form>
                        <div className="d-flex w-100 justify-content-between mt-3 mb-3">
                            <Link className="fs18 loginFooter border-none text-decoration-none" to="/">
                                {t('Back to home')}
                            </Link>
                            <Link className="fs18 loginFooter border-none text-decoration-none" to="/login">
                                {t('Back to login')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default inject('authStore', 'commonStore')(applicationRouter(withLocalization(observer(SignUpPage))));
